import { createStore } from "redux";
import createRootReducer from "./reducers";

export const store = createStore(createRootReducer());
